import React from "react";
import {
  Box,
  Typography,
  Container,
  Stack,
  Link,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { hydhero, hydhero3, hydhero4 } from "../../assets";

const HeroHook: React.FC = () => {
  return (
    <>
      {/* HERO SECTION */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "31vh", md: "70vh" },
          width: "100%",
          display: "flex",
          alignItems: "center",
          backgroundImage: `
            linear-gradient(
              to right,
              rgba(12, 32, 56, 0.85) 0%,
              rgba(12, 32, 56, 0.75) 40%,
              rgba(12, 32, 56, 0.55) 70%,
              rgba(12, 32, 56, 0.4) 100%
            ),
            url("${hydhero4}")
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ color: "#fff", maxWidth: "900px" }}>
            {/* Name */}
            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif !important",
                fontSize: { xs: "42px", md: "72px" },
                fontWeight: 600,
                letterSpacing: "1px",
                mb: 2,
                color:'white',
                textAlign:"start"
              }}
            >
              Rajiv Williams
            </Typography>

            {/* Tagline */}
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "18px" },
                lineHeight: 1.6,
                opacity: 0.95,
                mb: 2,
                 color:'white',
                //  fontFamily: "'Playfair Display', serif !important",
                 textAlign:"start"
              }}
            >
              Luxury Sales Mastery Coach • Consultative Selling Expert •
              TGRERA Licensed Realtor • Real Estate Investment Consultant •
              Brand Strategist • HRA & NAR India Member
            </Typography>

            {/* Location */}
            <Typography
              sx={{
                fontSize: { xs: "16px", md: "20px" },
                fontWeight: 500,
                color:'white',
                //  fontFamily: "'Playfair Display', serif !important",
                 textAlign:"start"
              }}
            >
              Hyderabad, Telangana, India
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* CONTACT BAR */}
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          py: 2,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={3}
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <PhoneIcon fontSize="small" />
              <Link href="#" underline="hover" color="inherit">
                +91 98854 20885
              </Link>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <EmailIcon fontSize="small" />
              <Link href="#" underline="hover" color="inherit">
                connect@rajivwilliams.com
              </Link>
              
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <LinkedInIcon fontSize="small" />
              <Link href="#" underline="hover" color="inherit">
                LinkedIn Profile
              </Link>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <LocationOnIcon fontSize="small" />
              <Link href="#" underline="hover" color="inherit">
                Hyderabad, Telangana, India
              </Link>
              
            </Stack>
          </Stack>
        </Container>
      </Box>
    <Box
  sx={{
    height: "20px",
    backgroundColor: "#f2f2f2",
    boxShadow: "inset 0 6px 10px -6px rgba(0,0,0,0.2)",
  }}
/>
    </>
  );
};

export default HeroHook;